// extracted by mini-css-extract-plugin
module.exports = {"content":"content___3YoMK","container":"container___3nXF5","rowBadge":"rowBadge___3-Zk0","rowHeading":"rowHeading___2aFhV"};